// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { AsyncDialog, DialogConfig } from '@aipb/shared/dialog';
import { Injectable } from '@angular/core';
import { CoopMessagesDialogComponent } from './coop-messages-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CoopMessagesDialogService extends AsyncDialog<CoopMessagesDialogComponent, void> {
  async loadComponent() {
    return import('./coop-messages-dialog.component').then((r) => r.CoopMessagesDialogComponent);
  }

  dialogConfig(): DialogConfig {
    return {
      width: '500px',
      maxHeight: '600px',
      position: {
        top: '68px',
        right: '20px'
      }
    };
  }
}
